var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10.75,
    fill: "#F4F5F6",
    stroke: "#00B67A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.584 19H14.4097V12.1318H15.584V19ZM14.3145 10.3101C14.3145 10.1196 14.3716 9.95882 14.4858 9.82764C14.6043 9.69645 14.7778 9.63086 15.0063 9.63086C15.2349 9.63086 15.4084 9.69645 15.5269 9.82764C15.6453 9.95882 15.7046 10.1196 15.7046 10.3101C15.7046 10.5005 15.6453 10.6592 15.5269 10.7861C15.4084 10.9131 15.2349 10.9766 15.0063 10.9766C14.7778 10.9766 14.6043 10.9131 14.4858 10.7861C14.3716 10.6592 14.3145 10.5005 14.3145 10.3101Z",
    fill: "#00B67A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.301060182f5af49ad323bccd3024d2d1.svg";
export { ForwardRef as ReactComponent };